<script setup lang="ts">
import stackedCountryImports from '@/charts/home/stacked-country-imports'

const props = defineProps<{
    country?: Country['iso']
    values?: Import[]
}>()

/**
 * Use countries.
 */
const { getName } = useCountries()

/**
 * Number formatter for import values.
 */
const format = importsValueFomatter()

/**
 * Total of all imports values for the selected country.
 */
const total = computed(() => {
    return props.values
        ?.find(value => value.country === props.country)
        ?.products.reduce((acc, product) => {
            return acc + product.import_value
        }, 0)
})

/**
 * Chart container.
 */
const container = ref<HTMLElement>()

/**
 * Chart options.
 */
const chartOptions = computed(() => {
    return stackedCountryImports(props.values || [], props.country)
})

/**
 * Chart instance.
 */
useChart(container, chartOptions)
</script>

<template>
    <div v-if="country" class="flex flex-1 flex-col p-4">
        <div class="text-center">
            <h1 class="text-xl font-bold">
                {{ getName(country) }}
            </h1>
            <p>{{ format(total || 0) }}</p>
        </div>
        <div ref="container" class="flex-1" />
    </div>
</template>